export type { EnvLabel } from './envLabel';
export { getNodeEnv, getEnvLabel } from './envLabel';

export type { CountryOption } from './countries';
export { COUNTRIES, COUNTRY_BY_CODE, countryCodeToFlag } from './countries';

export const ARTICLE_URL = '/articles';
export const TABLES_URL = '/tables';
export const NEWS_URL = '/news';
export const FIXTURES_URL = '/fixtures';
export const TOURNAMENTS_URL = '/tournaments';

// Storage key for tenant selection (used by TenantSwitcher in TEST env)
export const TENANT_STORAGE_KEY = 'slc_selected_tenant_id';

// SC-1163 — shared article image upload limits (apps/api + apps/admin)
export {
  ARTICLE_IMAGE_MAX_SIZE_BYTES,
  ARTICLE_IMAGE_MAX_SIZE_LABEL,
  ARTICLE_IMAGE_ACCEPTED_MIME_TYPES,
  ARTICLE_IMAGE_ACCEPTED_FORMATS_LABEL,
} from './articleImage';

// SC-669 + SC-1053 — the shared image upload rule, applied by every image endpoint in apps/api.
export {
  IMAGE_UPLOAD_MAX_SIZE_BYTES,
  IMAGE_UPLOAD_MAX_SIZE_LABEL,
  IMAGE_UPLOAD_ACCEPTED_MIME_TYPES,
  IMAGE_UPLOAD_ACCEPTED_FORMATS_LABEL,
  UNSUPPORTED_IMAGE_FORMAT_MESSAGE,
  IMAGE_TOO_LARGE_MESSAGE,
  IMAGE_UPLOAD_MAX_FILES,
  TOO_MANY_FILES_MESSAGE,
  imageUploadAcceptMap,
} from './imageUpload';

// Shared league-table point adjustment limits (apps/api + apps/admin)
export { POINT_AWARD_MAX_POINTS, POINT_ADJUSTMENT_REASON_MAX_LENGTH } from './pointAdjustments';

// Social Share poster paths (apps/admin through this barrel; apps/api imports '@constants/socialShare')
export type {
  SocialShareTemplate,
  SocialShareDraftTemplate,
  SocialSharePathParams,
  SocialShareClubNames,
  SocialShareNameOverflow,
  SocialShareFormat,
  SocialShareTieOrder,
} from './socialShare';
export {
  SOCIAL_SHARE_TEMPLATES,
  SOCIAL_SHARE_DRAFT_TEMPLATES,
  isDraftTemplate,
  SOCIAL_SHARE_CLUB_NAMES,
  SOCIAL_SHARE_NAME_OVERFLOWS,
  DEFAULT_SOCIAL_SHARE_CLUB_NAMES,
  DEFAULT_SOCIAL_SHARE_NAME_OVERFLOW,
  SOCIAL_SHARE_TITLE_MAX_LENGTH,
  SOCIAL_SHARE_SUBTITLE_MAX_LENGTH,
  SOCIAL_SHARE_FORMATS,
  SOCIAL_SHARE_FORMAT_SIZES,
  DEFAULT_SOCIAL_SHARE_FORMAT,
  SOCIAL_SHARE_MAX_PARTS,
  SOCIAL_SHARE_MAX_TIES,
  SOCIAL_SHARE_TIES_SEPARATOR,
  buildSocialSharePath,
  compareSocialShareTies,
  socialShareTeamName,
  defaultSocialShareSubtitle,
  socialShareLeagueShortName,
  socialSharePart,
  socialSharePartSizes,
} from './socialShare';

// Social Share drafts: the content of the Quote, Cup Draw, Announcement, Club Results and Goalscorers posters (apps/api
// imports '@constants/socialShareDraft')
export type {
  PhotoFit,
  PhotoCrop,
  PosterPhoto,
  NameStyle,
  ResolvedTeam,
  CupDrawEntry,
  ClubResultsMatch,
  PosterPoint,
  PosterLogoSize,
  PosterLogoStyle,
  QuoteDraft,
  QuotePhotoSide,
  AnnouncementDraft,
  CupDrawDraft,
  ClubResultsDraft,
  PosterCardScales,
  PosterCardCorner,
  GoalscorersLayout,
  GoalscorerGroup,
  GoalscorersCompetition,
  GoalscorerClub,
  GoalscorerRow,
  SocialShareGoalscorers,
  GoalscorersDraft,
  BackgroundDraft,
  SocialShareDraftData,
  StoredSocialShareDraft,
  SocialShareLeagueTeam,
} from './socialShareDraft';
export {
  DEFAULT_PHOTO_CROP,
  photoCropFor,
  PHOTO_FITS,
  photoFitOf,
  DEFAULT_QUOTE_FADE_LENGTH,
  QUOTE_FADE_LENGTH_MAX,
  quoteFadeLength,
  DEFAULT_ANNOUNCEMENT_SPLIT,
  ANNOUNCEMENT_SPLIT_RANGE,
  isAnnouncementSplit,
  announcementSplit,
  POSTER_LOGO_SIZES,
  DEFAULT_POSTER_LOGO_SIZE,
  POSTER_LOGO_SCALES,
  DEFAULT_POSTER_LOGO_BORDER_COLOUR,
  isPosterColour,
  isPosterLogoSize,
  readPosterLogoStyle,
  POSTER_CARD_SCALE_RANGE,
  DEFAULT_POSTER_CARD_SCALE,
  isPosterCardScale,
  posterCardScale,
  POSTER_CARD_CORNERS,
  GOALSCORERS_LAYOUTS,
  QUOTE_PHOTO_SIDES,
  NAME_STYLES,
  posterTeamName,
  RICH_TEXT_ALLOWED_TAGS,
  RICH_TEXT_FONT_SIZE_PRESETS_PX,
  RICH_TEXT_FONT_SIZE_RANGE_PX,
  RICH_TEXT_FONT_SIZE_STEPS_EM,
  isAllowedPosterStyle,
  SOCIAL_SHARE_LIMITS,
  DEFAULT_ANNOUNCEMENT_LABEL,
  DEFAULT_GOALSCORERS_TITLE,
  DEFAULT_GOALSCORERS_LIMIT,
  goalscorerRanks,
  goalscorerFootnote,
  goalscorerRowCount,
  goalscorerGroups,
  goalscorerGroupLabel,
  withGoalscorerNames,
  noGoalscorersText,
  shortSeasonLabel,
} from './socialShareDraft';
